import React from 'react';
import styled from 'styled-components';

export const Loading = () => {
  return (
    <LoadingWrapper>
      <svg
        width="50px"
        height="50px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        style={{ background: 'none' }}
      >
        <circle
          cx="50"
          cy="50"
          fill="none"
          stroke="var(--theme-secondary-color)"
          strokeWidth="10"
          r="35"
          strokeDasharray="164.93361431346415 56.97787143782138"
          transform="rotate(185.748 50 50)"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            calcMode="linear"
            values="0 50 50;360 50 50"
            keyTimes="0;1"
            dur="1s"
            begin="0s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </LoadingWrapper>
  );
};

const LoadingWrapper = styled.div`
  font-family: sans-serif;
  display: flex;
  justify-content: center;
`;
